import '../../css/supervisorcontrolls/supervisorstatus.css';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import SupervisorMenu from './supervisormenu';
import ChatsList from '../chat/chatslist';
import { setShowChat } from '../../redux/chatSlice';

function SupervisorControlls(props) {

    const { t } = useTranslation();
    const togglerRef = useRef(null);
    const [showSettings, setShowSettings] = useState(false);
    const chatRef = useRef(null);
    const openChatRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!openChatRef.current.contains(e.target) && chatRef.current && !chatRef.current.contains(e.target)) {
                props.setShowChat(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        //UNMOUNT
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chatRef]);

    const toggleChat = () => {
        props.setShowChat(!props.showChat);
    };

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    return (
        <div className="d-flex align-items-center flex-row-auto">
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {t("addwidgets")}
                </Tooltip>}>
                <div className="d-flex align-items-center ms-1">
                    <Button variant="light" onClick={e => { e.preventDefault(); props.updateView("widgets") }}><FontAwesomeIcon size='lg' icon={duotone("hexagon-plus")} /></Button>
                </div>
            </OverlayTrigger>
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {t("chat")}
                </Tooltip>}>
                <div className="d-flex align-items-center ms-1">
                    <Button ref={openChatRef} variant="light" onClick={toggleChat} className='position-relative'><FontAwesomeIcon size='lg' icon={duotone("messages")} />
                        {
                            (props.chats != null && props.chats.length > 0) &&
                            <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-50 start-75 animation-blink"></span>
                        }
                    </Button>
                </div>
            </OverlayTrigger>
            <div className="d-flex align-items-center ms-1">
                <div ref={togglerRef} className="btn btn-flex align-items-center bg-hover-white bg-hover-opacity-10 py-2 px-2 px-md-3" onClick={e => { e.preventDefault(); toggleSettings() }}>

                    <div className="d-none d-md-flex flex-column align-items-end justify-content-center me-2 me-md-4">
                        <span className="text-white opacity-75 fs-8 lh-1 mb-1 mx-2">{props.name}</span>
                    </div>
                    <div className="symbol symbol-30px symbol-md-40px">
                        {
                            (!props.image) &&
                            <div className='user-img text-primary bg-light-primary'>{props.initials}</div>
                        }

                        {
                            (props.image) &&
                            <img src={`//${props.image}`} alt="profile" />
                        }
                    </div>
                </div>
                <SupervisorMenu showSettings={showSettings} toggleSettings={toggleSettings}></SupervisorMenu>
            </div>

            <div ref={chatRef} className={"bg-body drawer drawer-end " + (props.showChat ? "drawer-on" : "drawer-end")}
                style={{ width: "500px", marginTop: "70px" }}>
                <ChatsList toggleChat={toggleChat}></ChatsList>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        name: state.supervisor.name,
        image: state.supervisor.image,
        initials: state.supervisor.initials,
        userId: state.supervisor.userId,
        showChat: state.chat.showChat,
        chats: state.chat.chats
    };
};

export default connect(mapStateToProps, { setShowChat })(SupervisorControlls);
